export const DEFAULT_CATEGORY_COLOUR = '#C5A059';
export function validColour(value) { return /^#[0-9a-f]{6}$/i.test(value || ''); }
export function luminance(hex) {
    const channels = hex.slice(1).match(/../g).map(v => parseInt(v,16)/255).map(v => v <= .04045 ? v/12.92 : ((v+.055)/1.055)**2.4);
    return channels[0]*.2126 + channels[1]*.7152 + channels[2]*.0722;
}
export function readableText(colour) {
    const l = luminance(validColour(colour) ? colour : DEFAULT_CATEGORY_COLOUR);
    return (l+.05)/.05 >= 1.05/(l+.05) ? '#000000' : '#ffffff';
}
export function appointmentColours(appointment, menu) {
    const treatments = appointment.treatments || [appointment];
    const active = treatments.filter(t => !['canceled','cancelled','rejected','no-show','no_show','noshow'].includes((t.status || '').toLowerCase()));
    const categories = (active.length ? active : treatments).map(t => {
        const service = (menu?.calendar_services || menu?.services)?.find(s => Number(s.id) === Number(t.serviceId));
        return (menu?.calendar_categories || menu?.categories)?.find(c => Number(c.id) === Number(service?.categoryId));
    }).filter(Boolean);
    return [...new Map(categories.map(c => [c.id, {name:c.name, colour:validColour(c.calendar_colour) ? c.calendar_colour : DEFAULT_CATEGORY_COLOUR}])).values()];
}
